<script lang="ts">
  import { addRoute } from '@integro/core';
  import { gettext, pgettext, ngettext, npgettext } from '@integro/gettext';
  addRoute({
    name: 'invoiceGeneration',
    path: '/invoice-generation',
    component: 'InvoiceGeneration',
    title: () => pgettext('InvoiceGeneration/title', 'Invoice generation'),
  });
  addRoute({
    name: 'draftInvoices',
    path: '/draft-invoices',
    component: 'InvoiceGeneration',
    title: () => pgettext('InvoiceGeneration/title', 'Invoice generation'),
  });
</script>

<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    userComponentProps,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'InvoiceGeneration',
  });

  const componentMetadata = {
    kind: 'page',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    ...userComponentProps,
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const tabManager = ref(null);
  const ux = ref({
    initialLoadSpinner: true,
  });
  const b_7315092382398562_noShow = computed(() => false);
  const b_7315092382398562_modalBindings = computed(() => ({
    size: 'md',
  }));

  const $data = computed(() => ({
    tabManager: tabManager.value,
    ux: ux.value,
    b_7315092382398562_noShow: b_7315092382398562_noShow.value,
    b_7315092382398562_modalBindings: b_7315092382398562_modalBindings.value,
  }));

  const $$load_tabManager = () => {
    return new $app.value.utils.LazyTabManager();
  };

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [
      { name: 'tabManager' },
      { name: 'ux' },
      { name: 'b_7315092382398562_noShow', nodeId: '7315092382398562' },
      { name: 'b_7315092382398562_modalBindings', nodeId: '7315092382398562' },
    ],
    loaders: { tabManager: $$load_tabManager },
    ux: { initialLoadSpinner: true },
    dataRefs: {
      tabManager,
      ux,
      b_7315092382398562_noShow,
      b_7315092382398562_modalBindings,
    },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  const pageDocument = computed(() => {
    return {
      title: $fn.value.pgettext(
        'InvoiceGeneration/title',
        'Invoice generation'
      ),
      icon: $config.value.invoiceGeneration.icon,
    };
  });
  const documentTitle = computed(() => {
    return pageDocument.value
      ? Array.isArray(pageDocument.value.title)
        ? pageDocument.value.title.filter(Boolean).join(' ')
        : pageDocument.value.title
      : null;
  });

  watch(
    pageDocument,
    (newDoc) => {
      if (newDoc) {
        _pageDocument.value = newDoc;
      }
    },
    { immediate: true }
  );

  const act_7315092382398562_closeModal_j4wqwmkzi_getActionArgs = async (
    $event
  ) => {
    return {
      name: props.modalName,
      result: {
        close: true,
        cancel: true,
      },
    };
  };

  const act_7315092382398562_closeModal_j4wqwmkzi =
    new actionTypes.CloseModalAction({
      actionArgs: act_7315092382398562_closeModal_j4wqwmkzi_getActionArgs,
    });
  const inst_evh_7315092382398562_close_z0o65ytvd =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_closeModal_j4wqwmkzi,
      event: 'close',
      displayName: 'closeModal',
    });
  const inst_evh_7315092382398562_close = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_close_z0o65ytvd],
    event: 'close',
  });
  const act_7315092382398562_reloadComponentData_4xe1qud69 =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_ktbovz5ss =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_4xe1qud69,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_ktbovz5ss],
    event: 'reload',
  });
  const act_2248226175642056_closeModal_8o3vchxe5 =
    new actionTypes.CloseModalAction({});
  const inst_evh_2248226175642056_close_vhy67hapi =
    new actionTypes.EventHandlerImpl({
      action: act_2248226175642056_closeModal_8o3vchxe5,
      event: 'close',
      displayName: 'closeModal',
    });
  const inst_evh_2248226175642056_close = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_2248226175642056_close_vhy67hapi],
    event: 'close',
  });
  const act_6466705138206980_reloadComponentData_fyih67gb7 =
    new actionTypes.ReloadComponentDataAction({
      displayName: 'reload',
    });
  const inst_evh_6466705138206980_clickPreventStop_qxty29d3x =
    new actionTypes.EventHandlerImpl({
      action: act_6466705138206980_reloadComponentData_fyih67gb7,
      event: 'click.prevent.stop',
      displayName: 'reload',
    });
  const inst_evh_6466705138206980_clickPreventStop =
    new actionTypes.EventHandlerGroup({
      handlers: [inst_evh_6466705138206980_clickPreventStop_qxty29d3x],
      event: 'click.prevent.stop',
    });

  const actions = {
    inst_evh_7315092382398562_close_z0o65ytvd,
    inst_evh_7315092382398562_close,
    inst_evh_7315092382398562_reload_ktbovz5ss,
    inst_evh_7315092382398562_reload,
    inst_evh_2248226175642056_close_vhy67hapi,
    inst_evh_2248226175642056_close,
    inst_evh_6466705138206980_clickPreventStop_qxty29d3x,
    reload: inst_evh_6466705138206980_clickPreventStop_qxty29d3x,
    inst_evh_6466705138206980_clickPreventStop,
  };

  const evh_7315092382398562_close_z0o65ytvd = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_close_z0o65ytvd.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_close = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_close.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload_ktbovz5ss = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_ktbovz5ss.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_2248226175642056_close_vhy67hapi = async (event, scope) => {
    return await actions.inst_evh_2248226175642056_close_vhy67hapi.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_2248226175642056_close = async (event, scope) => {
    return await actions.inst_evh_2248226175642056_close.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_6466705138206980_clickPreventStop_qxty29d3x = async (
    event,
    scope
  ) => {
    return await actions.inst_evh_6466705138206980_clickPreventStop_qxty29d3x.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_6466705138206980_clickPreventStop = async (event, scope) => {
    return await actions.inst_evh_6466705138206980_clickPreventStop.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    documentTitle,
    pageDocument: _pageDocument,
    routeTab,
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpPage
    :header="documentTitle"
    :loaded="loaded"
    :noShow="b_7315092382398562_noShow"
    :loading="showLoadingIndicator"
    :reloading="reloading"
    :error="error"
    :modal="modal"
    :modalBindings="b_7315092382398562_modalBindings"
    itp-cname="InvoiceGeneration"
    @close="evh_7315092382398562_close($event, {})"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <MaterialTabs
      :closeButton="modal"
      :tabManager="tabManager"
      no-content-wrapper
      :title="pgettext('InvoiceGeneration/title', 'Invoice generation')"
      v-if="loaded"
      @close="evh_2248226175642056_close($event, {})"
    >
      <template #actions>
        <ItpButton
          variant="light"
          icon="fa-sync-alt"
          :text="gettext('Reload')"
          size="sm"
          :spinning="actions.reload.isRunning"
          @click.prevent.stop="
            evh_6466705138206980_clickPreventStop($event, {})
          "
        >
        </ItpButton>
      </template>
      <BTab
        :title="pgettext('InvoiceGeneration|TabHeader', 'Invoices')"
        class="h-100 overflow-hidden p-0"
      >
        <UcInvoiceGenerationInvoices :reload="lastLoaded" class="h-100">
        </UcInvoiceGenerationInvoices>
      </BTab>
      <BTab
        :title="pgettext('InvoiceGeneration|TabHeader', 'Controlling')"
        class="h-100"
      >
        <UcInvoiceGenerationControlling
          :reload="lastLoaded"
          class="h-100"
          v-if="tabManager.visited(1)"
        >
        </UcInvoiceGenerationControlling>
      </BTab>
      <BTab
        :title="pgettext('InvoiceGeneration|TabHeader', 'Invoice lines')"
        class="h-100"
      >
        <UcInvoiceGenerationInvoiceLines
          :reload="lastLoaded"
          class="h-100"
          v-if="tabManager.visited(2)"
        >
        </UcInvoiceGenerationInvoiceLines>
      </BTab>
    </MaterialTabs>
  </ItpPage>
</template>
